import { render, staticRenderFns } from "./ConfigManagement.vue?vue&type=template&id=1859cd67&scoped=true"
import script from "./ConfigManagement.vue?vue&type=script&lang=js"
export * from "./ConfigManagement.vue?vue&type=script&lang=js"
import style0 from "./ConfigManagement.vue?vue&type=style&index=0&id=1859cd67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1859cd67",
  null
  
)

export default component.exports